import messageCountUnread from './messageCountUnread';

export default {
    /** 获取用所有类型的未读消息数量 */
    messageCountUnread,
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/message/index.ts